import { Popup } from "components/UI/Popup";
import "./styles/VerifyStatusPopup.scss";

interface IVerifyStatusPopup {
  isShowPopup: boolean;
  content: string;
  handleTogglePopup: () => void;
}

export const VerifyStatusPopup = ({ isShowPopup, content, handleTogglePopup }: IVerifyStatusPopup) => {
  return (
    <Popup
      title="Verification status"
      isOpen={isShowPopup}
      className="VerifyStatusPopup"
    >
      <div className="VerifyStatusPopup-Cnt">
        <p>{content}</p>
        <button onClick={handleTogglePopup}>Dismiss</button>
      </div>
    </Popup>
  );
};
